import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import {
  useLayoutDetection,
  useSelectedTheme,
  useTranslate,
} from '../../../Hooks';
import { TOGGLE_LAYOUT } from '../../../store/layout/Actions';
import { useVerticalNav } from '../../../Contexts/VerticalNavContext';
import {
  AfterSalesSummaryCardsListSkeleton,
  CustomBadge,
  CustomBreadCrumb,
  CustomButton,
  PageTitle,
} from '../../../Components';
import WalletTransactionsSummaryCards from './components/WalletTransactionsSummaryCards';
import WalletTransactionsFilters from './components/WalletTransactionsFilters';
import WalletTransactionsTable from './components/WalletTransactionsTable';
import {
  AgentWalletReportExport,
  GetAgentWalletKpis,
  GetAgentWalletReport,
} from '../../../Services';
import { UploadIcon } from '../../../assets/icons';

import useStyles from './styles';
function WalletTransactionsView() {
  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();
  const { setAlertBoxContent } = useVerticalNav();

  const {
    theme: { palette },
  } = useSelectedTheme();
  const styles = useStyles();

  const { translate } = useTranslate('WalletTransactionsView');
  const isNewLayout = isReskinningLayout && hasNewLayout;
  const dispatch = useDispatch();
  const [filters, setFilters] = useState({
    pageIndex: 1,
    pageSize: 25,
  });
  const [KPIsData, setKPIsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [reportData, setReportData] = useState({
    result: [],
    totalCount: 0,
  });

  const getAgentWalletReport = async () => {
    setIsLoading(true);
    try {
      const res = await GetAgentWalletReport({
        ...filters,
      });
      setReportData({
        result: res?.result,
        totalCount: res?.totalCount,
      });
    } catch {
      setAlertBoxContent({
        display: true,
        variant: 'error',
        title: 'Error fetching agent wallet report',
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportClick = async () => {
    try {
      await AgentWalletReportExport({
        ...filters,
      });
      setAlertBoxContent({
        display: true,
        variant: 'success',
        title: 'Report exported successfully',
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    } catch {
      setAlertBoxContent({
        display: true,
        variant: 'error',
        title: 'Error fetching agent wallet report',
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    }
  };

  const getAgentWalletKpis = async () => {
    try {
      const res = await GetAgentWalletKpis();
      setKPIsData(res);
    } catch (error) {
      setAlertBoxContent({
        display: true,
        variant: 'error',
        title: 'Error fetching agent wallet KPIs',
        onClose: () => {
          setAlertBoxContent(null);
        },
      });
    }
  };
  useEffect(() => {
    getAgentWalletReport();
  }, [filters]);

  useEffect(() => {
    if (!isNewLayout) {
      dispatch(TOGGLE_LAYOUT());
    }
  }, []);

  useEffect(() => {
    getAgentWalletKpis();
  }, []);
  return isNewLayout ? (
    <Box className={styles.container}>
      <CustomBreadCrumb
        breadcrumbs={[
          {
            label: translate('bread-crump-parent'),
            nonClickable: true,
          },
        ]}
      >
        <CustomBadge
          Style={{
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '20px',
          }}
          label={translate('bread-crump-current')}
          BackgroundColor={palette.breadcrumbs.brand_bg_hover}
          BorderColor={palette.breadcrumbs.brand_bg_hover}
          Color={palette.breadcrumbs.brand_fg_hover}
        />
      </CustomBreadCrumb>
      <PageTitle
        wrapperClasses={styles.title}
        title={translate('page-title')}
        subTitle={translate('page-subtitle')}
        hideDivider
      >
        <CustomButton
          onClick={handleExportClick}
          size='lg'
          color='secondary'
          variant='outlined'
          startIcon={
            <UploadIcon
              width={20}
              height={20}
              fill={palette.button.secondary_fg}
            />
          }
        >
          Export CSV
        </CustomButton>
      </PageTitle>
      <Box className={styles.cardsContainer}>
        {isLoading ? (
          <AfterSalesSummaryCardsListSkeleton numberOfCards={4} />
        ) : (
          <WalletTransactionsSummaryCards KPIsData={KPIsData} />
        )}
      </Box>

      <WalletTransactionsFilters
        filters={filters}
        setFilters={setFilters}
      />
      <WalletTransactionsTable
        filters={filters}
        reportData={reportData}
        setFilters={setFilters}
      />
    </Box>
  ) : null;
}

export default WalletTransactionsView;
